export const getters = {
    route: (state) => {
        return state.route;
    },
    country: (state) => {
        return state.country;
    },
    inquiry: (state) => {
        return state.inquiry;
    },
    travelData: (state) => {
        return state.travelData;
    },
    phoneValid: (state) => {
        return state.phoneValid;
    },
    emailValid: (state) => {
        return state.emailValid;
    },
    mailchimpSignup: (state) => {
        return state.mailchimpSignup
    },
    phoneCountry: (state) => {
        return state.travelData.user.phoneCountry || 'DE';
    },
    pending: (state) => {
        return state.pending;
    },
    error: (state) => {
        return state.error;
    },
    advisedBudget: (state) => {
        return state.advisedBudget;
    },
    isAsiInquiry: (state) => {
        return state.travelData?.inquiryType === 'inquiry-asi';
    },
};
